import { API_ROUTES } from "../utils/apiRoutes";
import { server } from "../utils/server";

export const createOrder = async (course) => {
  const response = await server.post(API_ROUTES.PAYMENT.CREATE, { course });
  return response.data;
};
